'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBearerToken = exports.generateAuthorizeURL = undefined;

var _queryString = require('query-string');

var _httpClient = require('http-client');

var generateAuthorizeURL = exports.generateAuthorizeURL = function generateAuthorizeURL(client_id, redirect_uri, state) {
  var force_reapprove = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return 'https://www.dropbox.com/1/oauth2/authorize?' + (0, _queryString.stringify)({
    response_type: 'code',
    client_id: client_id,
    redirect_uri: redirect_uri,
    state: state,
    force_reapprove: force_reapprove
  });
};

var getData = function getData(response) {
  var data = response.jsonData;

  if (data.error) throw new Error(data.error + ': ' + data.error_description);

  return data;
};

var getAccessToken = function getAccessToken(data) {
  return data.access_token;
};

var returnToken = (0, _httpClient.createStack)((0, _httpClient.parseJSON)(), (0, _httpClient.handleResponse)(getData), (0, _httpClient.handleResponse)(getAccessToken));

var getBearerToken = exports.getBearerToken = function getBearerToken(client_id, client_secret, code, redirect_uri) {
  return (0, _httpClient.createFetch)((0, _httpClient.method)('POST'), (0, _httpClient.params)({
    client_id: client_id,
    client_secret: client_secret,
    grant_type: 'authorization_code',
    redirect_uri: redirect_uri,
    code: code
  }), returnToken)('https://api.dropboxapi.com/1/oauth2/token');
};


//////////////////
// WEBPACK FOOTER
// ./~/dropbox-client/lib/DropboxAuth.js
// module id = 99
// module chunks = 0